'use client';

import { createContext, useContext } from 'react';
import { RoundedModalContainerWidth } from '../rounded-modal/rounded-modal';

type DrawerOrModalContextType = {
  isAboveBreakpoint: boolean;
  showCloseButton: boolean;
  /** Width variant for the modal container. It's passed through context to let the footer know if it needs to be reversed. */
  modalWidth: RoundedModalContainerWidth;
};

export const DrawerOrModalContext = createContext<DrawerOrModalContextType | undefined>(undefined);

export const useDrawerOrModalContext = () => {
  const context = useContext(DrawerOrModalContext);
  if (!context) {
    throw new Error('useDrawerOrModalContext must be used within DrawerOrModal');
  }
  return context;
};
